import React from 'react';
import ReactDOM from 'react-dom';
import 'babel-polyfill';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

const updateAvailablePromise = registerServiceWorker();
ReactDOM.render(<App update={updateAvailablePromise}/>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js